export { intersectNode };

function intersectNode(node, point) {
  return node.intersect(point);
}
